import { useState } from "react";

import Dropdown from "/src/components/common/Form/Wrapper/Dropdown";
import List from "/src/components/common/Form/List";

function shouldRender(options) {
  return options?.length > 0;
}

function readValue(value) {
  if (typeof value === "string") {
    return value;
  }
  if (value?.label) {
    return value?.label;
  }
}

function Component({ className, dropdownProps, formValues, isMulti, onChange, options, optionFilter, optionConditional, value }) {

  const [isOpen, setIsOpen] = useState(false);

  const getSelectValue = () => {
    if (Array.isArray(value)) {
      if (value.length === 1) {
        return readValue(value[0]);
      }
      if (value.length > 1) {
        return "Multiple";
      }
    }
    else if (value) {
      return readValue(value);
    }
    else {
      return false;
    }
  }

  const handleChange = (newValue) => {
    if (typeof onChange === "function") {
      onChange(newValue);
    }
    if (!isMulti) {
      setIsOpen(false);
    }
  };

  const conditionalFilter = () => {
    if (typeof optionFilter === "function") {
      return options.filter(item => optionFilter(item, formValues));
    }
    if (typeof optionConditional === "function") {
      return optionConditional(formValues);
    }
    return options;
  }

  if (shouldRender(options)) {
    const selectValue = getSelectValue();
    const buttonProps = { ...dropdownProps?.buttonProps, variant: selectValue ? "secondary" : "light" };
    dropdownProps = { ...dropdownProps, buttonProps, ...(selectValue && { label: selectValue }) };
    return (
      <Dropdown {...dropdownProps} isOpen={isOpen} setIsOpen={setIsOpen}>
        <List
          isMulti={isMulti}
          options={conditionalFilter()}
          onChange={handleChange}
          value={value}
        />
      </Dropdown>
    );
  }

  return null;

}

export default Component;
